import FETCH_CMS from "./cms";
import GET_SELLER_DATA from "./getSellerData";
import CMS from "./newCMS";

export { FETCH_CMS, GET_SELLER_DATA, CMS };
